"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("./authenticated.client");
class ProjectClient extends authenticated_client_1.AuthenticatedClient {
    getAll(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects?` + this.getQueryString({ fields });
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    get(id, options = []) {
        return __awaiter(this, void 0, void 0, function* () {
            const fields = options instanceof Array ? options : options.fields;
            const withFlags = options instanceof Array ? false : !!options.withFlags;
            const response = yield this.httpGet(`/v1/projects/${id}?` + this.getQueryString({ fields, withFlags }));
            return response.payload;
        });
    }
    create(project) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects`, project);
            return response.payload;
        });
    }
    update(project) {
        return __awaiter(this, void 0, void 0, function* () {
            const projectId = project.id;
            if (!projectId) {
                throw new Error('Project id not provided.');
            }
            delete project.id;
            const response = yield this.httpPut(`/v1/projects/${projectId}`, project);
            return response.payload;
        });
    }
    getFlags(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/flags`, { throwOnError: false });
            if (response.success) {
                return response.payload;
            }
        });
    }
    updateFlags(projectId, flags) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/projects/${projectId}/flags`, flags);
            return response.payload;
        });
    }
    setFlags(projectId, flags) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/flags`, flags);
            return response.payload;
        });
    }
    getUsers(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users`);
            return response.payload;
        });
    }
    getSettings(projectId, settingType, fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/${settingType}-settings?${this.getQueryString({ fields })}`, { throwOnError: false });
            if (response.success) {
                return response.payload;
            }
        });
    }
    setSettings(projectId, settingType, settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/${settingType}-settings`, settings);
            return response.payload;
        });
    }
    updateSettings(projectId, settingType, settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/projects/${projectId}/${settingType}-settings`, settings);
            return response.payload;
        });
    }
    getLatestTagSnapshot(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/tag-snapshots/latest`, {
                throwOnError: false,
            });
            if (response.success) {
                return response.payload;
            }
        });
    }
    buildTagSnapshot(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/dcb/snapshot/${projectId}/build`);
            return response.payload;
        });
    }
    getSdkSettingsV2(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/projects/${projectId}/sdk-settings`, { throwOnError: false });
            if (response.success) {
                return response.payload;
            }
        });
    }
    getSdkProjectPackage(os, packageName) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/projects/packages/${os}/${packageName}`, { throwOnError: false });
            return response.payload;
        });
    }
    updateSdkSettingsV2(projectId, settings) {
        return __awaiter(this, void 0, void 0, function* () {
            settings = Object.assign(Object.assign({}, settings), { id: undefined, createdAt: undefined, updatedAt: undefined, deletedAt: undefined, creatorId: undefined, updaterId: undefined, salesforceId: undefined, project: undefined });
            const response = yield this.httpPut(`/v2/projects/${projectId}/sdk-settings`, settings);
            return response.payload;
        });
    }
    renew(projectId, collectionDuration) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/demos/${projectId}/renew?${this.getQueryString({ collectionDuration })}`, {});
            return response.payload;
        });
    }
    convertFromDemo(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/demos/${projectId}/convert`);
            return response.payload;
        });
    }
    getProxySettingsById(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/proxy-settings`);
            return response.payload;
        });
    }
    getIndustriesForProject(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/industries`);
            return response.payload;
        });
    }
    getAccountForProject(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/account`);
            return response.payload;
        });
    }
    getAmwTheme(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/theme`);
            return response.payload;
        });
    }
    putAmwTheme(projectId, theme) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/theme`, theme);
            return response.payload;
        });
    }
}
exports.ProjectClient = ProjectClient;
var ProjectSettingType;
(function (ProjectSettingType) {
    ProjectSettingType["Tag"] = "tag";
})(ProjectSettingType = exports.ProjectSettingType || (exports.ProjectSettingType = {}));
//# sourceMappingURL=project.client.js.map